import { render, staticRenderFns } from "./user.vue?vue&type=template&id=3b2cf4f7&scoped=true"
import script from "./user.vue?vue&type=script&lang=js"
export * from "./user.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2cf4f7",
  null
  
)

export default component.exports